import { useCallback, useEffect, useRef } from 'react';

/**
 * For a loader whose answers can arrive out of order.
 *
 * Switching the month twice quickly sends two requests; if the first answers last, its
 * rows land under the second month's heading, and whatever the admin then does to the
 * selection acts on invoices from the wrong month. Each load calls `begin()` and keeps
 * the check it returns; only the latest load may write its answer to state.
 *
 *   const begin = useLatestRequest();
 *   const isCurrent = begin();
 *   const result = await fetch();
 *   if (!isCurrent()) return;
 */
export const useLatestRequest = (): (() => () => boolean) => {
  const latest = useRef(0);
  // an answer that arrives after unmount is never current
  useEffect(
    () => () => {
      latest.current += 1;
    },
    []
  );
  return useCallback(() => {
    const id = ++latest.current;
    return () => id === latest.current;
  }, []);
};
